<template>
  <f7-page name="referral-addded" class="modern-ui">
    <bc-navbar></bc-navbar>
    <div class="page-container">

      <img src="../../assets/raf/check-finish.png" alt="checked image">

      <h2 class="title">Referral Added!</h2>
      <p class="subtitle">
        Thanks for adding your referral’s name to this link!
      </p>

      <div class="info-card" type="info">
        <div class="icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M6.16395 3.9178C7.88837 3.78271 9.61939 3.75218 11.3475 3.82637C11.4646 3.83152 11.5816 3.81356 11.6918 3.77349C11.802 3.73342 11.9033 3.67203 11.9898 3.59283C12.0762 3.51363 12.1463 3.41817 12.1959 3.3119C12.2455 3.20563 12.2736 3.09063 12.2788 2.97347C12.284 2.85631 12.266 2.73928 12.2259 2.62906C12.1859 2.51884 12.1245 2.41759 12.0453 2.3311C11.9661 2.2446 11.8707 2.17455 11.7644 2.12495C11.6582 2.07535 11.5432 2.04716 11.4261 2.042C9.62607 1.96354 7.82298 1.99503 6.02683 2.13629C3.91284 2.30059 2.39592 4.12209 2.23165 6.19361C1.92278 10.0581 1.92278 13.9411 2.23165 17.8055C2.39592 19.8771 3.91284 21.7 6.02397 21.8629C7.20666 21.9543 8.35221 22 9.50062 22C10.6476 22 11.7946 21.9543 12.9773 21.8629C15.0884 21.7 16.6053 19.8771 16.7696 17.8055C16.8581 16.6779 16.921 15.5554 16.9581 14.4382C16.9604 14.205 16.8714 13.9801 16.71 13.8116C16.5487 13.6432 16.3278 13.5446 16.0947 13.537C15.8616 13.5293 15.6348 13.6132 15.4627 13.7707C15.2907 13.9282 15.1871 14.1468 15.1741 14.3797C15.137 15.4692 15.0751 16.5645 14.9884 17.6655C14.8827 19.0184 13.9243 19.9985 12.8387 20.0828C10.6167 20.2564 8.38453 20.2564 6.16252 20.0828C5.07696 19.9985 4.11853 19.0184 4.0114 17.6655C3.71137 13.8942 3.71137 10.105 4.0114 6.33362C4.11853 4.98213 5.07696 4.00066 6.16252 3.9178M17.001 2.11058C16.0243 2.11134 15.088 2.49981 14.3975 3.19065C13.7071 3.88149 13.319 4.81821 13.3186 5.79502C13.3186 6.88507 12.9358 7.9394 12.2374 8.77658L12.1674 8.85944C12.0805 8.96373 12.0252 9.09061 12.0078 9.22523C11.9905 9.35984 12.0118 9.49662 12.0694 9.61954C12.1269 9.74246 12.2183 9.84643 12.3328 9.91929C12.4473 9.99215 12.5802 10.0309 12.7159 10.0309H15.9654V10.6738C15.9654 10.9106 16.0595 11.1377 16.2269 11.3052C16.3943 11.4726 16.6214 11.5667 16.8581 11.5667C17.0949 11.5667 17.322 11.4726 17.4894 11.3052C17.6568 11.1377 17.7509 10.9106 17.7509 10.6738V10.0309H21.2861C21.4218 10.0309 21.5547 9.99215 21.6692 9.91929C21.7837 9.84643 21.875 9.74246 21.9326 9.61954C21.9901 9.49662 22.0115 9.35984 21.9941 9.22523C21.9768 9.09061 21.9214 8.96373 21.8346 8.85944L21.7646 8.77658C21.0665 7.93986 20.6839 6.88479 20.6833 5.79502C20.6829 4.81821 20.2949 3.88149 19.6045 3.19065C18.914 2.49981 17.9776 2.11134 17.001 2.11058ZM6.99955 17.5684C6.99955 16.8784 7.55947 16.3198 8.24937 16.3198H10.759C11.0905 16.3198 11.4084 16.4515 11.6428 16.6859C11.8772 16.9203 12.0088 17.2383 12.0088 17.5698C12.0088 17.9013 11.8772 18.2193 11.6428 18.4537C11.4084 18.6882 11.0905 18.8199 10.759 18.8199H8.24937C7.9179 18.8199 7.6 18.6882 7.36561 18.4537C7.13122 18.2193 6.99955 17.9013 6.99955 17.5698"
              fill="currentColor" />
          </svg>
        </div>

        <div class="title">Get notified about your referral's progress</div>

        <p>We'll send you updates when your referred customer takes action at {{ companyName }} - from browsing inventory to making a purchase.</p>
      </div>

      <div class="info-card">
        <div class="info-card-header">
          <div class="icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M13.7743 5.78905L14.0863 3.70256C14.1369 3.37056 14.3024 3.06422 14.5565 2.83223C14.8105 2.60024 15.1386 2.45592 15.4886 2.42222C15.8878 2.38555 16.2865 2.49627 16.6027 2.7316C16.9188 2.96692 17.1284 3.30892 17.1881 3.68718C17.2479 4.06544 17.1533 4.45116 16.9239 4.76491C16.6945 5.07865 16.3476 5.29654 15.9549 5.37371L13.7743 5.78905ZM10.7143 8.46583V11.7362H3.42857C3.20124 11.7362 2.98323 11.65 2.82248 11.4967C2.66173 11.3434 2.57143 11.1354 2.57143 10.9186V9.28342C2.57143 9.06658 2.66173 8.85862 2.82248 8.70529C2.98323 8.55197 3.20124 8.46583 3.42857 8.46583H10.7143ZM12 2.02978C11.7305 1.57329 11.3686 1.1725 10.9351 0.850756C10.5017 0.529013 10.0055 0.292746 9.47541 0.155715C8.94531 0.0186844 8.39194 -0.0163703 7.8475 0.0525924C7.30306 0.121555 6.77846 0.293157 6.30423 0.557403C5.83 0.821649 5.41564 1.17326 5.08526 1.59175C4.75489 2.01024 4.51512 2.48725 4.37991 2.995C4.2447 3.50275 4.21676 4.03108 4.29771 4.54923C4.37866 5.06738 4.56689 5.56498 4.85143 6.01306H3.42857C2.51926 6.01306 1.64719 6.35762 1.00421 6.97093C0.361224 7.58424 0 8.41607 0 9.28342V10.9186C1.52888e-05 11.4926 0.158444 12.0566 0.459363 12.5537C0.760282 13.0509 1.19309 13.4637 1.71429 13.7507V19.0945C1.71429 20.3955 2.25612 21.6432 3.22059 22.5632C4.18507 23.4832 5.49317 24 6.85714 24H17.1429C18.5068 24 19.8149 23.4832 20.7794 22.5632C21.7439 21.6432 22.2857 20.3955 22.2857 19.0945V13.7507C22.8069 13.4637 23.2397 13.0509 23.5406 12.5537C23.8416 12.0566 24 11.4926 24 10.9186V9.28342C24 8.41607 23.6388 7.58424 22.9958 6.97093C22.3528 6.35762 21.4807 6.01306 20.5714 6.01306H19.1486C19.4367 5.56487 19.628 5.06633 19.7115 4.54666C19.7949 4.02699 19.7687 3.49666 19.6344 2.98678C19.5001 2.4769 19.2604 1.99772 18.9294 1.57737C18.5984 1.15701 18.1827 0.803922 17.7068 0.538821C17.2308 0.27372 16.7042 0.101939 16.1577 0.0335523C15.6112 -0.034834 15.0559 0.00155126 14.5244 0.140574C13.9928 0.279597 13.4957 0.518459 13.0623 0.84315C12.6288 1.16784 12.2676 1.57183 12 2.03141M13.2857 8.87626V11.7362H20.5714C20.7988 11.7362 21.0168 11.65 21.1775 11.4967C21.3383 11.3434 21.4286 11.1354 21.4286 10.9186V9.28342C21.4286 9.06658 21.3383 8.85862 21.1775 8.70529C21.0168 8.55197 20.7988 8.46583 20.5714 8.46583H13.2857V8.87626ZM10.7143 14.1889H4.28571V19.0945C4.28571 19.745 4.55663 20.3689 5.03887 20.8288C5.5211 21.2888 6.17516 21.5472 6.85714 21.5472H10.7143V14.1889ZM13.2857 21.5472V14.1889H19.7143V19.0945C19.7143 19.745 19.4434 20.3689 18.9611 20.8288C18.4789 21.2888 17.8248 21.5472 17.1429 21.5472H13.2857ZM9.91371 3.70256L10.2257 5.78905L8.04514 5.37371C7.65235 5.29654 7.30553 5.07865 7.0761 4.76491C6.84667 4.45116 6.7521 4.06544 6.81186 3.68718C6.87162 3.30892 7.08116 2.96692 7.39733 2.7316C7.7135 2.49627 8.11224 2.38555 8.51143 2.42222C8.86137 2.45592 9.18946 2.60024 9.44354 2.83223C9.69763 3.06422 9.86312 3.37056 9.91371 3.70256Z"
                fill="currentColor" />
            </svg>
          </div>

          <div class="title">Strike while it's hot!</div>
          <div class="subtitle">
            More referrals = more rewards
          </div>
        </div>

        <div class="info-card-body">
          <p>Think of more people?
            <br>
            Share on social media!
          </p>
          <f7-link @click="addReferral()">Earn bonuses for <br> more referrals!</f7-link>
        </div>

        <div class="info-card-footer">
          <f7-link @click="addReferral()" class="mui-button w-100 accent">
            <send-icon/>
            Refer more friends
          </f7-link>

          <f7-link @click="openHistory()" class="mui-button w-100 stroked accent">
            <external-link-icon/>
            Open history
          </f7-link>
        </div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import { PAGES } from '../../shared/routes.constants'
import { mapState } from 'vuex'
import ExternalLinkIcon from '@components/icons/external-link.icon.vue'
import SendIcon from '@components/icons/send.icon.vue'
export default {
  name: 'referral-form-page',
  components: {
    ExternalLinkIcon,
    SendIcon
  },
  computed: {
    ...mapState({
      companyName: (state) => state.common.companyName
    })
  },
  methods: {
    addReferral () {
      this.$router.load({ url: PAGES.RecommendAFriendReferral })
    },
    openHistory () {
      this.$router.load({ url: PAGES.RecommendAFriendHistory })
    }
  },
  data () {
    return {
    }
  }
}
</script>
<style scoped lang="scss">
@import '~@/sass/modern-ui/card.scss';
@import '~@/sass/modern-ui/button.scss';

.page-container {
  padding-inline: 18px;
  padding-block: 8px 16px;
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  >.title {
    font-weight: 600;
    font-size: 28px;
    padding: 0;
  }

  >.subtitle {
    font-weight: 500;
    font-size: 16px;
    margin: 0;
  }

  >*+* {
    margin-top: 24px;
  }
}

.info-card {
  width: 100%;
  box-sizing: border-box;

  &:nth-of-type(1) {
    display: grid;
    grid-template-columns: 42px 1fr;
    align-items: center;
    column-gap: 10px;
    row-gap: 4px;

    p {
      margin: 0;
      line-height: 1.2;
    }

    .icon {
      width: 42px;
      grid-row: span 2;
    }
  }

  &:nth-of-type(2) {
    display: grid;
    gap: 16px;
    align-items: start;

    .info-card-header {
      display: grid;
      grid-template-columns: 42px 1fr;
      align-items: center;
      column-gap: 10px;
      row-gap: 4px;

      .icon {
        width: 42px;
        grid-row: span 2;
      }

      .title {
        align-self: end;
        line-height: 1;
      }

      .subtitle {
        align-self: start;
        line-height: 1;
      }
    }

    .info-card-body {
      display: flex;
      gap: 16px;
      align-items: center;

      >* {
        flex: 1;
        text-align: left;
        font-size: 16px;
        line-height: 1.2;
      }

      p {
        margin: 0;
      }
    }

    .info-card-footer {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// referral-added.vue?29c8f6c9